function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CatalogTileBadge from './CatalogTileBadge';

const defaultTruncateDescription = (text, max) => {
  if (max === -1 || typeof text !== 'string' || text.length <= max) {
    return text;
  }

  return React.createElement(React.Fragment, null, text.substring(0, max - 3), "\u2026");
};

class CatalogTile extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      heightStyle: {}
    });

    _defineProperty(this, "handleDescriptionRef", ref => {
      if (!ref) {
        return;
      }

      this.descFullHeight = ref.clientHeight;
    });

    _defineProperty(this, "handleDescriptionSpanRef", ref => {
      if (!ref) {
        return;
      }

      this.descLineHeight = parseInt(window.getComputedStyle(ref).getPropertyValue('line-height'), 10);
    });

    _defineProperty(this, "handleClick", e => {
      const {
        onClick,
        href
      } = this.props;

      if (!href) {
        e.preventDefault();
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(this, "renderBadges", badges => {
      if (!badges || !badges.length) {
        return null;
      }

      return React.createElement("div", {
        className: "catalog-tile-pf-badge-container"
      }, badges.map((badge, index) => React.createElement("span", {
        key: `badge-${index}`
      }, badge)));
    });
  }

  componentDidMount() {
    this.computeDescHeight();
  }

  computeDescHeight() {
    const heightStyle = {};

    if (this.descFullHeight && this.descLineHeight) {
      heightStyle.maxHeight = `${Math.floor(this.descFullHeight / this.descLineHeight) * this.descLineHeight}px`;
    }

    this.setState({
      heightStyle
    });
  }

  render() {
    const _this$props = this.props,
          {
      id,
      className,
      featured,
      href,
      onClick,
      icon,
      iconImg,
      iconAlt,
      iconClass,
      badges,
      title,
      vendor,
      description,
      truncateDescriptionFn,
      maxDescriptionLength,
      footer
    } = _this$props,
          otherProps = _objectWithoutProperties(_this$props, ["id", "className", "featured", "href", "onClick", "icon", "iconImg", "iconAlt", "iconClass", "badges", "title", "vendor", "description", "truncateDescriptionFn", "maxDescriptionLength", "footer"]);

    const {
      heightStyle
    } = this.state;
    const truncateDescription = truncateDescriptionFn || defaultTruncateDescription;
    const classes = classNames('catalog-tile-pf', {
      featured
    }, className);
    const OuterComponent = href || onClick ? ({
      children
    }) => React.createElement("a", _extends({
      id: id,
      className: classes,
      href: href || '#'
    }, otherProps, {
      onClick: e => this.handleClick(e)
    }), children) : ({
      children
    }) => React.createElement("div", _extends({
      id: id,
      className: classes
    }, otherProps), children);
    return React.createElement(OuterComponent, null, React.createElement("div", {
      className: "catalog-tile-pf-header"
    }, iconImg && React.createElement("img", {
      className: "catalog-tile-pf-icon",
      src: iconImg,
      alt: iconAlt
    }), !iconImg && (iconClass || icon) && React.createElement("span", {
      className: `catalog-tile-pf-icon ${iconClass}`
    }, icon), this.renderBadges(badges)), React.createElement("div", {
      className: "catalog-tile-pf-body"
    }, React.createElement("div", {
      className: "catalog-tile-pf-title"
    }, title), React.createElement("div", {
      className: "catalog-tile-pf-subtitle"
    }, vendor), React.createElement("div", {
      className: "catalog-tile-pf-description",
      ref: this.handleDescriptionRef,
      style: heightStyle
    }, React.createElement("span", {
      ref: this.handleDescriptionSpanRef
    }, truncateDescription(description, maxDescriptionLength, id)))), footer && React.createElement("div", {
      className: "catalog-tile-pf-footer"
    }, footer));
  }

}

CatalogTile.propTypes = {
  /** Id */
  id: PropTypes.any,

  /** Additional css classes */
  className: PropTypes.string,

  /** Flag if the tile is 'featured' */
  featured: PropTypes.bool,

  /** href for the tile if used as a link */
  href: PropTypes.string,

  /** Callback for a click on the tile */
  onClick: PropTypes.func,

  /** URL of an image for the item's icon */
  iconImg: PropTypes.string,

  /** Alternate text for the item's icon */
  iconAlt: PropTypes.string,

  /** Class for the image when an icon is to be used (exclusive from iconImg) */
  iconClass: PropTypes.string,

  /** Alternatively provided JSX for the icon */
  icon: PropTypes.node,

  /** Array of badges */
  badges: PropTypes.arrayOf(PropTypes.node),

  /** Tile for the catalog item */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /** Vendor for the catalog item */
  vendor: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Description of the catalog item */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Max description length before applying truncation (when description is a string), -1 for auto truncate to last visible line */
  maxDescriptionLength: PropTypes.number,

  /** Truncation function(description, max, id) used to truncate description when necessary (defaults to using ellipses) */
  truncateDescriptionFn: PropTypes.func,

  /** Footer for the tile */
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};
CatalogTile.defaultProps = {
  id: null,
  className: '',
  featured: false,
  href: null,
  onClick: null,
  iconImg: null,
  iconAlt: '',
  iconClass: '',
  icon: null,
  badges: [],
  vendor: null,
  description: null,
  maxDescriptionLength: -1,
  truncateDescriptionFn: null,
  footer: null
};
CatalogTile.displayName = 'CatalogTile';
CatalogTile.Badge = CatalogTileBadge;
export default CatalogTile;